import * as React from 'react';
import { Row, Col, Button } from 'reactstrap';
import SeatPlanModal from 'app/modules/seat-plan/seat-plan-modal';

export interface ISeatPlanState {
  showModal: boolean;
  zoneName: string;
}

export class SeatPlan extends React.Component<ISeatPlanState> {
  state: ISeatPlanState = {
    showModal: false,
    zoneName: ''
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  openModal = zoneName => {
    this.setState({ zoneName, showModal: true });
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  render() {
    return (
      <Row className="justify-content-center">
        <SeatPlanModal showModal={this.state.showModal} handleClose={this.handleClose} tickets={[]} zoneName={this.state.zoneName} />
        <Col md="8" className="bg-white">
          <Row className="justify-content-center">
            <Col md="8" className="m-3">
              <h1>麥花臣</h1>
              <br />
              <Button onClick={() => this.openModal('STALLS')}>STALLS</Button>
              <Button onClick={() => this.openModal('1 SECTION')}>1 SECTION</Button>
              <Button onClick={() => this.openModal('2 SECTION')}>2 SECTION</Button>
              <Button onClick={() => this.openModal('3 SECTION')}>3 SECTION</Button>
              <Button onClick={() => this.openModal('7 SECTION')}>7 SECTION</Button>
              <Button onClick={() => this.openModal('8 SECTION')}>8 SECTION</Button>
              <Button onClick={() => this.openModal('9 SECTION')}>9 SECTION</Button>
              <Button onClick={() => this.openModal('10 SECTION')}>10 SECTION</Button>
              <Button onClick={() => this.openModal('11 SECTION')}>11 SECTION</Button>
              <Button onClick={() => this.openModal('12 SECTION')}>12 SECTION</Button>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8" className="m-3">
              <h1>澳門百老匯</h1>
              <br />
              <Button onClick={() => this.openModal('F01')}>F01</Button>
              <Button onClick={() => this.openModal('F02')}>F02</Button>
              <Button onClick={() => this.openModal('F03')}>F03</Button>
              <Button onClick={() => this.openModal('101')}>101</Button>
              <Button onClick={() => this.openModal('102')}>102</Button>
              <Button onClick={() => this.openModal('103')}>103</Button>
              <Button onClick={() => this.openModal('105')}>105</Button>
              <Button onClick={() => this.openModal('106')}>106</Button>
              <Button onClick={() => this.openModal('M01')}>M01</Button>
              <Button onClick={() => this.openModal('M02')}>M02</Button>
              <Button onClick={() => this.openModal('M03')}>M03</Button>
              <Button onClick={() => this.openModal('M05')}>M05</Button>
              <Button onClick={() => this.openModal('M06')}>M06</Button>
              <Button onClick={() => this.openModal('201')}>201</Button>
              <Button onClick={() => this.openModal('202')}>202</Button>
              <Button onClick={() => this.openModal('203')}>203</Button>
              <Button onClick={() => this.openModal('205')}>205</Button>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8" className="m-3">
              <h1>澳門金光綜藝館</h1>
              <br />
              <Button onClick={() => this.openModal('SECTION 102')}>SECTION 102</Button>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8" className="m-3">
              <h1>九龍灣國際展貿中心Music Zone</h1>
              <br />
              <Button onClick={() => this.openModal('SECTION 1-1')}>SECTION 1-1</Button>
              <Button onClick={() => this.openModal('SECTION 1-2')}>SECTION 1-2</Button>
              <Button onClick={() => this.openModal('SECTION 2-1')}>SECTION 2-1</Button>
              <Button onClick={() => this.openModal('SECTION 2-2')}>SECTION 2-2</Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default SeatPlan;
